import { useMutation } from '@apollo/client/react';
import { useTheme } from '@emotion/react';
import { useAtom } from 'jotai';
import React, { useCallback, useEffect } from 'react';

import { Alert, Button, Modal, Text } from '~/components/blocks';
import { FinishEncounterDocument } from '~/graphql/generated/graphql';
import { finishConfirmModalState } from '~/state/partials/patient_profile_drawer/atoms';

export const FinishConfirmModal = () => {
  const theme = useTheme();
  const [state, setState] = useAtom(finishConfirmModalState);
  const close = useCallback(
    () => setState(() => ({ isOpen: false, encounterId: null, patientId: null, error: null })),
    [setState],
  );

  // 指導待ち -> 未会計 （telemedicine: true）
  const [
    finishEncounter,
    { data: finishEncounterData, loading: encounterFinishing, error: finishEncounterError },
  ] = useMutation(FinishEncounterDocument);
  const handleEncouterFinish = useCallback(async () => {
    if (state.encounterId) {
      finishEncounter({
        variables: { input: { encounterId: state.encounterId } },
      });
    }
  }, [finishEncounter, state.encounterId]);

  useEffect(() => {
    if (finishEncounterError) {
      setState((_state) => ({ ..._state, error: finishEncounterError.message }));
    }
  }, [finishEncounterError, setState]);

  useEffect(() => {
    if (finishEncounterData) {
      close();
    }
  }, [close, finishEncounterData]);

  return (
    <Modal open={state.isOpen} size="s" onClose={close}>
      <Modal.Header>
        <Text size="l">服薬指導を完了</Text>
      </Modal.Header>
      <Modal.Body>
        {state.error && <Alert mb={theme.space.l}>{state.error}</Alert>}
        <Alert status="warning" marginTop={theme.space.s}>
          下記のボタンを押して完了すると、オンラインでの服薬指導はできなくなります。
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button use="secondary" loading={encounterFinishing} onClick={handleEncouterFinish}>
          完了
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
